<template>
	<div class="layout-grid-category-picker"></div>
</template>

<script>
export default {
	props: {
		layoutType: null,
		createIfMissing: {
			default: true
		},
		orgId: null
	},
	methods: {
		loadLayoutCategories: function() {
			var userExtrasName = 'studioLayoutsLastCategory';

			var url = 'ajax/getLayoutCategories.php?createIfMissing=' + this.createIfMissing + '&getRecursive=false&type=' + this.layoutType;
			if(typeof this.orgId !== 'undefined') {
				url += '&orgId=' + this.orgId;
				userExtrasName = 'layoutsLastCategory-' + this.orgId;
			}
			if(this.layoutType !== 'Candid') {
				userExtrasName += '-' + this.layoutType;
			}

			if(this.categoryPicker) {
				$(this.categoryPicker).remove();
			}

			var me = this;
			this.categoryPicker = new $.CategoryPicker('LayoutCategory', {
				autoLoad: {
					ajax: {
						url: url
					},
					default: $.userExtras[userExtrasName]
				},
				onCategoriesChange: function(layoutCategories) {
					if(typeof me.orgId === 'undefined') {
						$.proxyAjax({
							url: 'ajax/bookFormats.php',
							dataType: 'json',
							success: function(data) {
								var bookFormats = data.data;
								me.$emit('onCategoriesChange', layoutCategories, bookFormats);
							}
						});
					} else {
						me.$emit('onCategoriesChange', layoutCategories);
					}
				},
				onCategoryChange: function(layoutCategory) {
					me.$emit('onCategoryChange', layoutCategory);
	
					if(layoutCategory && layoutCategory.id != $.userExtras[userExtrasName]) {
						$.ajax({
							url: 'ajax/saveUserExtra.php',
							dataType: 'json',
							data: {
								name: userExtrasName,
								value: layoutCategory.id
							},
							type: 'POST'
						});
	
						$.userExtras[userExtrasName] = layoutCategory.id;
					}
				}
			});
	
			$(this.$el).append(this.categoryPicker);
			this.$emit('registerCategoryPicker', this.categoryPicker);
		}
	},
	watch: {
		orgId: function(orgId) {
			this.loadLayoutCategories();
		}
	},
	mounted: function() {
		if(typeof this.orgId === 'undefined' || this.orgId !== null) {
			this.loadLayoutCategories();
		}
	}
};
</script>

<style scoped>
.layout-grid-category-picker {
	margin-right: 0.5em;
}
</style>